define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    const _ = require('underscore');
    const serverUtil = require('util/server.util');
    const LoginView = require('portlets/login/login.view');

    module.exports = LoginView.extend({

        userName: '',

        password: '',

        events: function() {
            const events = _.result(LoginView.prototype, 'events');

            return _.extend(events, {
                'input .fn-user-name': 'toggleSubmit',
                'input .fn-password': 'toggleSubmit',
                'change .fn-user-name': 'toggleSubmit',
                'change .fn-password': 'toggleSubmit'
            });
        },

        toggleSubmit: function(event) {
            const { name, value } = event.target;

            this[name] = value;

            this.$el.find('.fn-login-btn')[0].disabled = !(this.userName && this.password);
        },

        /**
         * @override
         */
        errorLogin: function(response) {
            const { data, data: { userErrors } = {} } = response || {};
            const errorMessage = userErrors?.UserError?.[0]?.message || userErrors?.[0]?.message;

            if (this.form.data('userName')) {
                this.form.el.elements.password.focus();
            } else {
                this.form.el.elements.userName.focus();
            }

            if (data?.errorCode === 3) {
                const spareMessage = data?.errorText || data?.errorMessage || errorMessage;
                const errorTranslation = 'playtech.mobile.system.login.error.' + data?.errorCode;

                this.form.showErrorMessage({
                    content: serverUtil.getMessageFromActions(response) || data.actions?.PlayerActionShowMessage?.[0]?.message || i18n.t(errorTranslation) || spareMessage
                });

                return;
            }

            return LoginView.prototype.errorLogin.call(this, response);
        },

        /**
        * @override
        */
        getIsLoginDeviceSupported: function() {}
    });
});
